<template>
	<div class="card md-elevation-4">
		<div style="display: flex; width: 100%">
			<div style="margin-top: auto; margin-bottom: auto">
				<md-icon class="md-size-2x" style="color: #ab47bc">loyalty</md-icon>
			</div>
			<div style="margin-left: auto; margin-right: 0px; margin-top: auto; margin-bottom: auto">
				<strong style="font-size: 32px">
					{{ count }}
				</strong>
			</div>
		</div>
		<span style="float: right">{{ $t("active-subscriptions") }}</span>
		<br />
	</div>
</template>
<script>
import { mapActions } from "vuex"
export default {
	name: "subscriptions-chart",
	data() {
		return {
			count: 0,
			stats: {
				this_year: 0
			},
			array: []
		}
	},
	methods: {
		...mapActions({
			doPayments: "payment/doPayments"
		})
	},

	async created() {
		this.array = await this.doPayments({})
		this.count = 0
		this.array.forEach(item => {
			var until = new Date(item.valid_until)
			if (until > new Date()) {
				this.count += 1
			}
		})
	}
}
</script>

<style scoped lang="scss">
.card {
	width: 300px;
	height: 125px;
	padding: 20px;
	border-radius: 15px;
	background-color: white;
	margin: 5px;
	&:hover {
		cursor: pointer;
	}
	color: #ab47bc;
}

.positive {
	color: green;
}
.negative {
	color: red;
}
.equal {
	color: gray;
}

span {
	font-family: "Montserrat", sans-serif;
}
</style>
